import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { ui } from './ui';
import { auth } from './auth';

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
    modules: {
        ui,
        auth
    }
};

export default new Vuex.Store<RootState>(store);
